import React, { useContext, useEffect, useRef, useState } from "react";
import Carosle from "./Components/Carosle";
import MenuList from "./Components/MenuList";
import HeaderInner from "./Components/HeaderInner";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import CustomLoader from "./Components/Loaders/CustomLoader";
import { ShowHomeMenu } from "./API/HomeMenuAPI";
import ErrorPage from "./Components/ErrorPage";
import Footer from "./Components/Footer";
import axios from "axios";
import axiosInstance from "./axios";
import { Toast } from "primereact/toast";
import { ThemeContext } from "./context/ThemeContext";
import { useBusinessNameContext } from "./context/BusinessName";
import AppPopup from "./Components/AppPopup";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGlobalContext } from "./context/GlobalContext";
import DOMPurify from "dompurify";
import FlexiDark from "./assets/images/Flexi-Dark.png";
import Flexi from "./assets/images/Flexi.png";
import FnbOrdersSlider from "./Components/FnbOrdersSlider";
function HomeMenu() {
  const { businessName, setBusinessName } = useBusinessNameContext();
  const { t } = useTranslation();
  const { setHeaderImages } = useGlobalContext();
  const business_name = localStorage.getItem("business_name");

  const lang = localStorage.getItem("lang");
  const params = useParams();
  const [isVerticalVideo, setIsVerticalVideo] = useState(false);
  const { theme, setTheme } = useContext(ThemeContext);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMedia, setPopupMedia] = useState({ type: null, src: null });
  const active_flexipass = localStorage.getItem("active_flexipass");
  console.log(active_flexipass, "flexi");
  // const { setTheme } = useContext(ThemeContext);

  console.log("themethemethemethemethemetheme", theme);

  const toast = useRef(null);
  const [doorLoading, setDoorLoading] = useState(false);
  const [doorConfirmOpen, setDoorConfirmOpen] = useState(false);

  const [quickServices, setQuickServices] = useState([]);
  const [serviceId, setServiceId] = useState(null);
  const [serviceOpen, setServiceOpen] = useState(false);
  const [serviceLoading, setServiceLoading] = useState(false);

  const handleCloseService = () => {
    setServiceOpen(false);
    setServiceId(null);
  };

  const selectQuickService = (service_id) => {
    setServiceOpen(true);
    setServiceId(service_id);
  };

  const bookQuickService = () => {
    setServiceLoading(true);

    axiosInstance
      .post(
        `/${params.room_uuid}/quick-services/book-service`,
        { service: serviceId },
        {
          headers: {
            lang: lang,
          },
        },
      )
      .then((res) => {
        setServiceLoading(false);
        toast.current.show({
          severity: "success",
          summary: t("Success"),
          detail: t(`${res.data.data.message}`),
          life: 4000,
        });
        handleCloseService();
      })
      .catch(() => {
        setServiceLoading(false);
        handleCloseService();
      });
  };

  const unlockDoor = () => {
    setDoorConfirmOpen(false);
    setDoorLoading(true);
    axiosInstance
      .post(`/${params.room_uuid}/flexipass/open-door`)
      .then((res) => {
        setDoorLoading(false);
        if (res.data.status === false) {
          toast.current.show({
            severity: "error",
            summary: t("Error"),
            detail: t(res.data.message || "Failed to unlock door."),
            life: 4000,
          });
        } else {
          const result = res.data.data?.[0];
          if (result?.openingSuccess) {
            toast.current.show({
              severity: "success",
              summary: t("Success"),
              detail: t("Door unlocked successfully"),
              life: 4000,
            });
          } else {
            toast.current.show({
              severity: "warn",
              summary: t("Warning"),
              detail: t(
                "Could not unlock the door. Please try again or contact the front desk.",
              ),
              life: 5000,
            });
          }
        }
      })
      .catch(() => {
        setDoorLoading(false);
        toast.current.show({
          severity: "error",
          summary: t("Error"),
          detail: t("Failed to unlock door. Please try again."),
          life: 4000,
        });
      });
  };

  const colorRef = useRef(null);
  let menu;
  let bgColor;
  let color;
  let headerImages;
  let logo;
  let services;
  let languages;
  let has_extra_services;
  let show_wifi_access = false;
  let last_fnb_orders = [];
  let show_printing_service = false;
  let show_quick_services = false;
  let notFound = "";
  const navigate = useNavigate();
  const { data, isLoading, error } = ShowHomeMenu(params.room_uuid, lang);
  // console.log("data", data.data);
  if (!isLoading) {
    if (data.data.status === false) {
      navigate(`/${params.room_uuid}/qr-scan`);
      // notFound = "Room Not Found";
    } else {
      menu = data.data.data;
      last_fnb_orders = menu?.last_fnb_orders || [];
      languages = menu.Languages;
      // const images = menu?.header_images.map((image) => {
      //   return image.image;
      // });
      headerImages = menu.realvideo
        ? [{ image: menu.realvideo }, ...menu?.header_images]
        : menu?.header_images;
      logo = menu?.logo;
      show_wifi_access = menu?.show_wifi_access;
      // show printing service
      show_printing_service = menu?.show_printing_service;
      show_quick_services = menu?.show_quick_services;
      services = menu?.activeServices;
      localStorage.setItem("has_extra_services", menu?.has_extra_services);
      localStorage.setItem(
        "is_grand_millennium_barsha_hotel",
        menu?.is_grand_millennium_barsha_hotel,
      );
      has_extra_services = menu?.has_extra_services;
      bgColor = menu?.header_color;
      color = menu?.color;
      // console.log("menumenu", menu);
      localStorage.setItem("logo", logo);
      localStorage.setItem("countryCode", menu?.country_code || "ae");

      // colorRef.current.style.setProperty('--color', menu?.color);
      document.documentElement.style.setProperty("--color", menu?.color);
      document.documentElement.style.setProperty(
        "--color_t",
        `${menu?.color}b3`,
      );
      document.documentElement.style.setProperty(
        "--color_car",
        `${menu?.color}69`,
      );
    }
    // localStorage.setItem("color", color)
    // localStorage.setItem("bgcolor", bgColor)
  }
  useEffect(() => {
    if (!isLoading && data?.data?.data) {
      const menu = data.data.data;
      setTheme(menu.use_new_design);
      const imgs = menu.realvideo
        ? [{ image: menu.realvideo }, ...menu?.header_images]
        : menu?.header_images;
      setHeaderImages(imgs);
    }
  }, [isLoading, data]);

  useEffect(() => {
    axiosInstance
      .get(`/${params.room_uuid}/quick-services`, {
        headers: {
          lang: lang,
        },
      })
      .then((res) => {
        setQuickServices(res.data.data.quickServices);
      })
      .catch(() => {
        setQuickServices([]);
      });
  }, [lang, params.room_uuid]);

  // Show popup when data loads with video or image
  useEffect(() => {
    if (!isLoading && data?.data?.data) {
      const menu = data.data.data;
      if (menu.real_popup_video) {
        setPopupMedia({ type: "video", src: menu.real_popup_video });
        setPopupOpen(true);
      } else if (menu.real_popup_image) {
        setPopupMedia({ type: "image", src: menu.real_popup_image });
        setPopupOpen(true);
      } else if (menu.real_popup_text) {
        setPopupMedia({ type: "text", src: menu.real_popup_text });
        setPopupOpen(true);
      }
    }
  }, [isLoading, data]);
  // useEffect(() => {
  //   const getData = async () => {
  //     // axios.get(`/648ed77e-da78-4987-9b86-de515659fc2c`).then((res) => {
  //     setLoading(true);

  //     axios.get(`/${params.room_uuid}`).then((res) => {
  //       const data = res?.data.data;
  //       if (res.data.status == false) {
  //         setError(res.data.message)
  //       }
  //       // console.log("res", res);
  //       setHeaderImages(data?.header_images);
  //       setLogo(data?.logo);
  //       setServices(data?.activeServices);
  //       setLoading(false);
  //       // console.log("d", data);
  //     }).catch((err) => {
  //       setLoading(false);
  //       setError(err?.message)
  //       // console.log("err", err);
  //     })
  //   };
  //   getData();
  // }, []);
  const showData = () => {
    if (isLoading) {
      return <CustomLoader businessName={businessName} />;
    }
    if (error) {
      return <ErrorPage des={error} />;
    }
    // if (notFound) {
    //   return <ErrorPage des={notFound} />;
    // }
    return (
      <>
        <HeaderInner
          logo={logo}
          bgColor={bgColor}
          color={color}
          languages={languages}
        />
        <main className="home-main pad-top-0">
          {businessName &&
            (businessName == "Grand Continental Hotel" ||
              businessName == "Royal M Hotel & Resort Abu Dhabi by Gewan") && (
              <AppPopup />
            )}
          <Carosle
            className={"dot-bar less-margin small-dots"}
            headerImages={headerImages}
            isFirst={true}
          />
          <div className="spacer-10 full-div"></div>
          <FnbOrdersSlider orders={last_fnb_orders} />
          {active_flexipass && active_flexipass !== "false" && (
            <div>
              <div className="flexi-container">
                <div className=" flexi-text-area">
                  <p className="prim-text">
                    Use your mobile device to securely unlock your room door.
                  </p>
                  {/* <p className="sub-text">Subtext test</p> */}
                </div>

                <button
                  className="flexi-btn"
                  onClick={() => setDoorConfirmOpen(true)}
                  disabled={doorLoading}
                >
                  {doorLoading ? t("Unlocking...") : t("Unlock Room Door")}
                </button>
              </div>
              <div className="spacer-10 full-div"></div>
            </div>
          )}
          {show_quick_services && quickServices?.length > 0 && (
            <div className="home-quick-services">
              {/* <h5>{t("Quick Services")}</h5> */}
              <div className="services_box">
                {quickServices.map((item) => {
                  return (
                    <span
                      key={item.id}
                      onClick={() => {
                        if (
                          item.name.includes("Feedback / Complaint") ||
                          item.name.includes("Hotel Review") ||
                          item.name.includes("Review / Complaint") ||
                          item.name.includes("Review") ||
                          item.name.includes("Feedback") ||
                          item.id == 4 ||
                          item.id == 7
                        ) {
                          navigate(`/${params.room_uuid}/feedback`);
                        } else {
                          selectQuickService(item.id);
                        }
                      }}
                    >
                      {t(`${item.name}`)}
                    </span>
                  );
                })}
              </div>
              <div className="spacer-10 full-div"></div>
            </div>
          )}
          <MenuList
            services={services}
            loading={isLoading}
            has_extra_services={has_extra_services}
            show_wifi_access={show_wifi_access}
            show_printing_service={show_printing_service}
          />{" "}
          {/* <pre>{JSON.stringify(services, null, 2)}</pre> */}
        </main>
        {/* <Footer /> */}
      </>
    );
  };

  return (
    <>
      {/* <HeaderInner logo={logo} bgColor={bgColor}
        color={color} /> */}
      {/* <main className="home-main pad-top-0"> */}
      {showData()}

      {/* </main> */}

      <Toast ref={toast} position="bottom-center" />

      <Modal
        show={doorConfirmOpen}
        onHide={() => setDoorConfirmOpen(false)}
        backdrop="static"
        className={`${theme && "food-modal"} rate_modal q_services_modal p-0`}
        style={{
          minHeight: "150px",
          padding: "0px !important",
          display: "flex !important",
          alignItems: "center !important",
          paddingRight: "0 !important",
        }}
      >
        <Modal.Body style={{ padding: "20px 10px", height: "auto" }}>
          <img
            src={FlexiDark}
            alt="Optemai Access"
            style={{
              width: "100%",
              maxHeight: "40px",
              objectFit: "contain",
              marginBottom: "12px",
            }}
          />
          <h5 style={{ color: theme ? "#e7e7e7" : "var(--color)" }}>
            {t("Are you sure you want to unlock your room door?")}
          </h5>
          <div className="servi_btns">
            <Button
              disabled={doorLoading}
              className="no"
              style={{
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#ffd28d" : "var(--color)",
              }}
              onClick={() => setDoorConfirmOpen(false)}
            >
              {t("No")}
            </Button>
            <Button
              disabled={doorLoading}
              className="yes"
              style={{
                background: theme ? "#ffd28d" : "var(--color)",
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#000" : "#fff",
              }}
              onClick={unlockDoor}
            >
              {t("Yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={serviceOpen}
        onHide={handleCloseService}
        backdrop="static"
        className={`${theme && "food-modal"} rate_modal q_services_modal p-0`}
        style={{
          minHeight: "150px",
          padding: "0px !important",
          display: "flex !important",
          alignItems: "center !important",
          paddingRight: "0 !important",
        }}
      >
        <Modal.Body style={{ padding: "20px 10px", height: "auto" }}>
          <h5 style={{ color: theme ? "#e7e7e7" : "var(--color)" }}>
            {t("Are you sure you want to submit the request?")}
          </h5>
          <div className="servi_btns">
            <Button
              disabled={serviceLoading}
              className="no"
              style={{
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#ffd28d" : "var(--color)",
              }}
              onClick={handleCloseService}
            >
              {t("No")}
            </Button>
            <Button
              disabled={serviceLoading}
              className="yes"
              style={{
                background: theme ? "#ffd28d" : "var(--color)",
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#000" : "#fff",
              }}
              onClick={bookQuickService}
            >
              {t("Yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Popup Modal for Video/Image */}
      <Modal
        show={popupOpen}
        onHide={() => setPopupOpen(false)}
        centered
        className={`${theme && "food-modal"} banner_popup home-banner-popup p-0`}
        style={{
          paddingRight: 0,
        }}
      >
        <Modal.Body
          style={{
            padding: "16px",
          }}
        >
          <div style={{ width: "100%", height: "100%", position: "relative" }}>
            <div>
              <button
                onClick={() => setPopupOpen(false)}
                className="popup-close-btn"
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  border: "none",
                  background: "var(--color)",
                  color: "white",
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  fontSize: "10px",
                  padding: "7px",
                  cursor: "pointer",
                  zIndex: 10,
                }}
              >
                <svg
                  className="w-5 h-5 text-gray-400"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            {popupMedia.type === "video" && (
              <div
                className="video-container"
                style={{
                  height: isVerticalVideo ? "90vh" : "auto",
                  maxWidth: "85vw",
                  maxHeight: "80vh",
                }}
              >
                <video
                  autoPlay
                  muted
                  playsInline
                  loop
                  onLoadedMetadata={(e) => {
                    const video = e.target;
                    setIsVerticalVideo(video.videoHeight > video.videoWidth);
                  }}
                >
                  <source src={popupMedia.src} type="video/mp4" />
                </video>
              </div>
            )}
            {popupMedia.type === "image" && (
              <img
                src={popupMedia.src}
                alt="Popup"
                style={{
                  width: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            )}
            {popupMedia.type === "text" && (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px 0px",
                  marginTop: "35px",
                  maxWidth: "90vw",
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    String(popupMedia.src.replace(/\n/g, "<br>")),
                  ),
                }}
              />
            )}
            {/* <div
              className={`${theme ? "banner-book" : "reg-btn"}`}
              style={{
                marginTop: "15px",
                textAlign: "center",
              }}
            >
              <a onClick={() => setPopupOpen(false)}>{t("Dismiss")}</a>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default HomeMenu;
